import Repository from "./Repository";

const GET_AUTHURL = "/";
const GET_TOKEN = "/getToken";
const LINKEDIN_USER_INFO = "/getUserInfo";

export default {
  getAuthUrl(payload) {
    return Repository.get(transformRoute(GET_AUTHURL), payload);
  },
  getToken(payload) {
    return Repository.post(transformRoute(GET_TOKEN), payload);
  },
  getUserInfo(payload) {
    return Repository.post(transformRoute(LINKEDIN_USER_INFO), payload);
  },
};
const transformRoute = (route) => {
  return `/linkedin${route}`;
};
